// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import ConfirmationController from "./confirmation_controller"
application.register("confirmation", ConfirmationController)

import DynamicSelectController from "./dynamic_select_controller"
application.register("dynamic-select", DynamicSelectController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import NestedFormController from "./nested_form_controller"
application.register("nested-form", NestedFormController)

import PhoneController from "./phone_controller"
application.register("phone", PhoneController)

import SearchFormValidationController from "./search_form_validation_controller"
application.register("search-form-validation", SearchFormValidationController)

import SelectController from "./select_controller"
application.register("select", SelectController)

import TooltipController from "./tooltip_controller"
application.register("tooltip", TooltipController)
